import React from 'react';
import { Box } from '@mui/material';
import useTranslations from "@/app/hooks/useTranslation";
import { useTheme } from "@/app/hooks/useTheme";
import { getDictionary, getField } from "@/app/utils/translation/translation";
import { getSvg } from "@/app/utils/svgUtils";





export default function Chatting({ isMobile }: { isMobile: boolean }) {
    const phoneNumber = '+971501286691';
    const { mode } = useTheme(); // Subscribe to theme changes to force re-render
    const {
        loading,
        translations,
        supportedLanguages,
        language,
        selectedLanguage,
        handleLanguageChange,
    } = useTranslations();
    const dictionary = getDictionary(translations, 'chatting', language);

    return (<> 
        <Box 
            style={{
                position: "fixed",
                bottom: "1rem",
                right: isMobile ? "0rem" : "1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                zIndex: 1000,
                padding: "0.5rem",
                borderRadius: "8px", 
                backgroundColor: "var(--section-bg)",
                transition: "background-color 0.3s ease"
            }}
        >
            <div>
                <a href={`https://wa.me/${phoneNumber}`} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <img src={`${process.env.NEXT_PUBLIC_IMAGE_PATH}/assests/images/whatsapp.svg`} loading='lazy' width={isMobile ? "100%" : "40%"} height={isMobile ? "60%" : "40%"} alt="whatsapp" />
                </a>
            </div>

            <Box 
                style={{
                    transform: "translateY(-10px)",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.875rem",
                    color: "var(--text-primary)",
                    marginTop: "0.5rem", 
                    backgroundColor: "var(--section-bg)",
                    transition: "background-color 0.3s ease, color 0.3s ease"
                }}
            >
                <span style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem"
                }}>
                    {getSvg('pathIcon', { yellow: 'var(--accent-secondary)', darkPurple: 'var(--accent-primary)' }, { width: 24, height: 24 }, { display: "inline-block" })}
                    <span>{getField(dictionary, 'chat-with-us', language)}</span>
                    {getSvg('chatIcon', { yellow: 'var(--accent-secondary)', mainPurple: 'var(--accent-primary)' }, { width: 24, height: 24 }, { display: "inline-block" })}
                </span>
            </Box>
        </Box>
    </>)
}